import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { RadioGroup, Radio, RadioError } from 'components/fields'
import { Button } from 'components/misc'
import { Title } from 'components/layout'
import { apiOrganizations } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import { logError } from 'redux/modules/app'
import { changeAwardUnitModeValidate } from 'models/award-units'

const enhance = compose(
  apiOrganizations({
    updateDetail: true
  }),
  form({
    form: 'change-award-unit-mode',
    validate: changeAwardUnitModeValidate
  }),
  connect(
    ({ api }) => ({
      codeLists: api.codeLists
    }),
    {
      logError
    }
  )
)

class AwardUnitChangeMode extends Component {
  static propTypes = {
    organisationId: PropTypes.number.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    codeLists: PropTypes.object.isRequired,
    changeOrganisationMode: PropTypes.func.isRequired,
    organizationMode: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    submitting: PropTypes.bool
  }

  static defaultProps = {
    values: {},
    codeLists: {},
    organisationId: null
  }

  componentDidMount = () => {
    this.props.initialize({
      organizationMode: this.props.organizationMode
    })
  }

  render() {
    const { organisationId, handleSubmit, submitting, codeLists } = this.props

    return (
      <form
        onSubmit={handleSubmit(fields =>
          this.props.changeOrganisationMode(organisationId, fields)
        )}
      >
        <div className="row">
          <div className="col-xs-12">
            <Title
              h2
              intlKey="heading.change_award_unit_mode"
              className="text--center"
            >
              Change organisation's mode
            </Title>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <RadioGroup>
              {codeLists.organizationModes.list.map(item => (
                <Radio
                  name="organizationMode.value"
                  key={item.value}
                  label={item.label}
                  value={item.value}
                />
              ))}
            </RadioGroup>

            <div className="base-margin--bottom">
              <RadioError name="organizationMode.value" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Button
              type="button"
              onClick={this.props.onClose}
              secondary
              intlKey="button.close"
            >
              Close
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button intlKey="button.change" isLoading={submitting}>
              Change
            </Button>
          </div>
        </div>
      </form>
    )
  }
}

export default enhance(AwardUnitChangeMode)
